<template>
    <div v-if="!fromStudentSubmitted" class="py-6">
        <e-button v-if="validFilesUpdated || readOnly" expanded class="py-6">
            <span
                class="is-flex is-align-items-center is-justify-content-center is-flex-wrap-wrap"
                :class="{
                    'is-flex-direction-column-mobile': true,
                    'is-flex-direction-row-tablet': true,
                }"
            >
                <e-icon icon="check" class="is-success" />

                <span class="ml-2 mt-2-mobile">File Uploaded in</span>

                <span class="has-text-primary ml-1 mt-2-mobile">Turnitin</span>

                <e-button class="button is-primary ml-2 mt-2-mobile" @click="onUploadFilesToTurnItIn">
                    View Assignment
                </e-button>
            </span>
        </e-button>

        <e-button v-else expanded :disabled="isDisabled" @click="onUploadFilesToTurnItIn">
            <e-icon icon="file-upload" /> Upload your files to <span class="has-text-primary ml-1">Turnitin</span>
        </e-button>
    </div>

    <lti-drawer
        v-model:active="isComponentModalActive"
        title="Edverum - Turnitin Integration"
        @close="reloadPage"
        @restore="loadLaunchData"
    >
        <div class="is-flex is-flex-direction-column is-height-full">
            <p class="mb-3">Please follow the steps below to complete submission.</p>

            <div class="turnitin-student-submission-container is-flex-grow-1">
                <div ref="ltiContainer" class="turnitin-student-iframe-container is-height-full" />

                <div class="is-flex is-justify-content-flex-end mt-2">
                    <e-button type="is-link" @click="reloadPage"> Submit </e-button>
                </div>
            </div>
        </div>
    </lti-drawer>
</template>

<script>
import { useI18n } from 'vue-i18n';
import LtiDrawer from '@/components/lti/LtiDrawer.vue';

export default {
    name: 'StudentTurnitinAssignmentUploader',
    components: { LtiDrawer },

    data() {
        return {
            isComponentModalActive: false,
        };
    },

    props: {
        multiple: Boolean,

        isDisabled: Boolean,

        readOnly: Boolean,

        validFilesUpdated: {
            type: Number,
            default: 0,
        },
        ltiResourceLinkId: {
            type: Number,
            required: true,
        },
        showStudentTurnitinSubmission: {
            type: Boolean,
            required: true,
        },
        fromStudentSubmitted: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    emits: ['update:modelValue', 'validation-error'],

    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },

    watch: {
        showStudentTurnitinSubmission: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.onUploadFilesToTurnItIn();
                }
            },
        },

        isComponentModalActive(val) {
            if (val) {
                this.loadLaunchData();
            }
        },
    },

    methods: {
        reloadPage() {
            window.location.reload();
        },
        onUploadFilesToTurnItIn() {
            this.isComponentModalActive = true;
        },

        async loadLaunchData(payload) {
            if (payload?.relaunch === false) {
                return;
            }

            if (this.ltiResourceLinkId) {
                this.$nextTick(() => {
                    const container = this.$refs.ltiContainer;

                    if (container) {
                        const launchUrl = `${import.meta.env.VITE_APP_URL}/lti/links/${this.ltiResourceLinkId}`;
                        const existingIframe = container.querySelector('iframe');

                        if (existingIframe?.dataset?.launchUrl === launchUrl) {
                            return;
                        }

                        container.innerHTML = '';
                        const iframe = document.createElement('iframe');
                        iframe.style.width = '100%';
                        iframe.style.height = '100%';
                        iframe.style.border = 'none';
                        iframe.src = launchUrl;
                        iframe.dataset.launchUrl = launchUrl;
                        container.appendChild(iframe);
                    }
                });
            }
        },
    },
};
</script>
